import { connect } from 'react-redux';
import FullScreenModal from './Full_screen_modal';

const mSTP = state => ({
  photos: state.fullScreenPhotos,
});

export default connect(mSTP)(FullScreenModal);
